import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export const WelcomeModal = ({ forceOpen = false, onForceClose }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const languages = [
    { code: 'es', name: 'Español' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'ca', name: 'Català' },
    { code: 'eu', name: 'Euskara' },
    { code: 'gl', name: 'Galego' },
    { code: 'it', name: 'Italiano' }
  ];

  useEffect(() => {
    if (forceOpen) {
      setIsOpen(true);
    } else {
      const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');
      if (!hasSeenWelcome) {
        setIsOpen(true);
      }
    }
  }, [forceOpen]);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setCurrentLang(langCode);
  };

  const handleClose = () => {
    localStorage.setItem('hasSeenWelcome', 'true');
    setIsOpen(false);
    if (onForceClose) onForceClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <img src="/logo-transparent.png" alt="AllergenApp Logo" className="w-32 h-32" />
          </div>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
            {t('welcomeMessage')}
          </p>
          <div className="flex flex-col gap-4">
            <Button 
              onClick={handleClose}
              className="w-full bg-[#8FBC8F] hover:bg-[#7CAA7C] py-6 text-lg"
              data-testid="download-app-btn"
            >
              {t('installOnMobile')}
            </Button>
            
            <div className="flex items-center justify-between gap-4">
              <select
                data-testid="welcome-language-selector"
                value={currentLang}
                onChange={(e) => changeLanguage(e.target.value)}
                className="text-sm border rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-[#8FBC8F]"
              >
                {languages.map((lang) => (
                  <option key={lang.code} value={lang.code}>
                    {lang.name}
                  </option>
                ))}
              </select>
              <Button 
                onClick={handleClose}
                variant="outline"
                data-testid="close-welcome-btn"
              >
                {t('close')}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};